<template>

    <div>
        <section class="top flex items-end"
            :class="{
                'allgone': !campaign?.is_gift_available,
                'extend': !campaign?.is_lottery_active,
            }">
            <!--魚油送完classname狀態 -> top 加 allgone -->
            <!-- 2/23號 0:00 後classname狀態 -> top 加 extend -->
            <div class="grid grid-4 w855">
                <img class="horse-show w209" :src="luckyboxStore.getAsset('/images/event/2026luckybox/horse_03.png')" alt="" />
                <img class="horse-show w213" :src="luckyboxStore.getAsset('/images/event/2026luckybox/horse_06.png')" alt="" />
                <img class="horse-show w209" :src="luckyboxStore.getAsset('/images/event/2026luckybox/horse-02_03.png')" alt="" />
                <img class="horse-show w213" :src="luckyboxStore.getAsset('/images/event/2026luckybox/horse-02_06.png')" alt="" />
            </div>
        </section>

        <section class="two gold-bg">
            <!--btn錨點-->
            <div class="btn-group w1100 grid grid-2-4">
                <a href="#p-P"><img :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-p-btn.png')" alt="前往調整體質按鈕"/></a>
                <a href="#p-S"><img :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-s-btn.png')" alt="前往消化調理按鈕"/></a>
                <a href="#p-C"><img :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-c-btn.png')" alt="前往美麗有感按鈕"/></a>
                <a href="#p-T"><img :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-t-btn.png')" alt="前往排便順暢按鈕"/></a>
            </div>
            <!--btn錨點 END-->
        </section>

        <BoxProbiotic @popup="handlePopup" />

        <BoxSProbiotic @popup="handlePopup" />

        <BoxCollagen @popup="handlePopup" />

        <BoxGutarget @popup="handlePopup" />

        <div class="pink-BG">

            <Lottery />

            <div class="note section-w w1100">
                <div class="note-box">
                    <div class="big-title text-2xl font-black">活動說明詳情</div>
                    <div class="note-content">
                        ※ 加碼延長至 2026.03.01 23:59 截止<br/>
                        <del>※ 前200筆購買福箱之訂單即贈送【德國KD原廠魚油】一包/60粒</del> (贈品已贈完)
                    </div>
                    <div class="note-title">金馬開運抽紅包(活動已於2026.02.23截止)</div>
                    <div class="note-content">
                        ※ 凡購買福箱完成結帳流程後，即獲得抽紅包機會乙次，點擊活動按鈕可返回活動頁面進行開獎，箱箱有獎。<br/>
                        ※ 抽紅包活動結束後，可至會員中心查看結果。<br/>
                        ※ 若選擇門市自取，需先完成結帳才可進行抽紅包。
                    </div>
                    <div class="note-title">注意事項</div>
                    <div class="note-content">
                        ※ 福箱屬限量優惠商品，售出後恕不退換。<br/>
                        ※ 全館免運 (員購共享商品金額不列入免運計算)。<br/>
                        ※ 凡於 2026/01/09 – 2026/02/13 期間下單者，將依正常流程進行出貨。<br/>
                        ※ 2026/02/14 – 2026/02/22 為農曆年節期間，此期間仍可正常下單，但因物流停止收送，訂單將於 2026/02/23 開工日後依序出貨。<br/>
                        ※ 因農曆春節物流量大及交通狀況影響，實際配送時間將以物流端狀態為準。<br/>
                        ※ 健康一刻保有本活動之修改、變更或暫停權利，如有未盡事宜，將以官網公告為主，並得隨時補充說明。<br/>
                        ※ 若購買之商品數量較多，超出本公司最大紙箱可容納之範圍，會將商品分箱打包出貨。
                    </div>
                </div>
            </div>
        </div>

        <Dialog v-model:visible="popupVisible" modal
            :closable="true"
            :dismissableMask="true"
            :draggable="false"
            :closeOnEscape="true"
            :closeOnBackdrop="true"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
            :style="{
                borderRadius: 0,
            }">
            <template #container="{ closeCallback }">
                <div :style="{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    height: '75vh',
                    position: 'relative',
                }">
                    <img :src="popupSrc" alt="popup" style="width: 100%; max-width: 100%;" />
                </div>
            </template>
        </Dialog>

        <Global :global="global" />
    </div>

</template>

<script setup>
import ApiClient from '../../../composables/api_client';
import { storeToRefs } from 'pinia';
import { ref, computed, onMounted, defineAsyncComponent } from 'vue';
import { useGlobalStore } from '../../../stores/useGlobalStore';
import { useLuckyboxStore } from '../../../stores/useLuckyboxStore';
import { Dialog } from 'primevue';
//
import BoxProbiotic from './box_probiotic.vue';
import BoxSProbiotic from './box_s_probiotic.vue';
import BoxCollagen from './box_collagen.vue';
import BoxGutarget from './box_gutarget.vue';
import Lottery from './lottery.vue';
import Global from '../../../components/global.vue';

const props = defineProps({
    global: {
        type: Object,
        required: true,
        default: () => ({}),
    },
    campaign: {
        type: Object,
        required: true,
        default: () => ({}),
    }
});

const globalStore = useGlobalStore();
const luckyboxStore = useLuckyboxStore();

const { is_loading, broadcast } = storeToRefs(globalStore);
const { states, cart, bundles, asset, campaign } = storeToRefs(luckyboxStore);

const popupVisible = ref(false);
const blankSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=';
const popupSrc = ref(blankSrc);

const initBundles = (data) => {
    const rows = {};
    //建立購物車格式
    Object.keys(data).forEach(k => {
        rows[k] = {
            base: data[k].base_qty,
            items: {},
        };
        const items = data[k]?.items ?? {};
        Object.keys(items).forEach(key => {
            rows[k].items[key] = 0;
        });
    });
    cart.value = rows;
    bundles.value = data;
};

const handlePopup = (src) => {
    popupVisible.value = !popupVisible.value;
    popupSrc.value = popupVisible.value ? src : blankSrc;
};

//
const fetch = async () => {

    // const api = route('hc.api.campaigns.show', {
    //     campaignId: campaign.value?.campaign_id ?? null
    // });

    const api = luckyboxStore.getAPIEndpoint('show');

    is_loading.value = true;
    states.value.is_finished = false;

    try {
        const response = await ApiClient.get(api);
        const data = response.data ?? {};

        if (data?.bundles) {
            initBundles(data.bundles);
        }

        if (location.hash) {
            history.scrollRestoration = 'manual';
            window.setTimeout(() => {
                if (states.value.is_finished) {
                    document.getElementById('lottery-box').scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }

    } catch (error) {
        console.error(error?.message);
    } finally {
        is_loading.value = false;
        states.value.is_finished = true;
    }
};

onMounted(async () => {
    asset.value = 'nothing.jpg?cv=17898265172';
    campaign.value = props.campaign;
    await fetch();
});

</script>
